module.exports = __webpack_public_path__ + "static/media/b1_p13_scout.8cfd6c65.mp3";